module.exports = __webpack_public_path__ + "img/usp_icon1.d017e470.svg";